import React from "react";
import parse from "html-react-parser";

export default function PluroAchievements({ title, data }) {
  return (
    <section className="pluro-achievements-wrapper">
      <div className="container">
        <h2 className="pluro-achievements-title">{parse(title)}</h2>
        
        <div className="pluro-stats-row">
          {data.map((item, index) => (
            <div className="pluro-stat-pill" key={index}>
              <span className="stat-number">{item.number}</span>
              <p className="stat-label">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
